<template>
    <div class="row">
        <div class="col-sm-6">
            <newQuote ref="buildQuote" @savedQuote="savedQuote($event)" @setQuote="quote = $event" 
                @setMethod="method = $event" :idCliente="idCliente" :idUser="idUsuario" :showSave="0"
                :isAdmin="isAdmin" :initialQuote="initialQuote" />
        </div>
        <div class="col-sm-2"></div>

        <div class="col-sm-4">
            <div class="sticky">
                <sumary :quote="quote" :method="method" @setResume="setResume($event)"
                    @setLeadTime="setLeadTimer($event)" />
                <div class="row mt-3" v-if="getPrice != 0">
                    <div class="col-sm-3">
                        <loadingbutton :loading="savingQuote" @pressed="saveQuote" :disabled="savingQuote"
                            buttonText="Add to Quote" />
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import newQuote from "@/components/quote/new-quote.vue";
import sumary from "@/page-start/components/sumary.vue";
import loadingbutton from "@/components/global/loading-button.vue";

export default {
    name: "assessment-page",
    props: ["idCliente", "idUsuario", "initialQuote"],
    data: function () {
        return {
            method: {},//pasa de newQ a resume
            quote:null,//pasa de newQ a resume
            files:[],
            isSaving:false,
            sendQuoteMail:true,
        }
    },
    components: {
        newQuote: newQuote,
        sumary: sumary,
        loadingbutton
    },
    computed:{
        getPrice(){
            if(this.quote != null){
                return this.quote.Price;
            }
            return 0;
        },
        savingQuote(){
            return this.$refs.buildQuote.isSaving;
        },
        isAdmin(){
            let usrr = this.$vtc.getUsuarioLogueado();
            if(usrr){
                return usrr.isAdmin
            }
            return false
        },
        
    },
    methods: {
        saveQuote() {
            //this.$refs.buildQuote.saveNewQuote(this.sendQuoteMail);
            this.$emit("savedAssessment",this.quote);
            this.$refs.buildQuote.resetAll();
        },
        savedQuote(q) {
            //alert("NO debe salir")
            this.$emit("savedAssessment", q);
            
            //para el proximo
            this.$refs.buildQuote.resetAll();

        },
        setResume(summary){
            if(this.quote){
this.quote.Resume = summary
            this.$refs.buildQuote.setResume(summary);
            }
            
        },
        setLeadTimer(isLeadTime){
            this.$refs.buildQuote.setLeadTime(isLeadTime);
        },
    }
};
</script>
